import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { LogtoProvider } from './auth/LogtoProvider';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AppShell } from './components/layout/AppShell';
import { ConversationsProvider } from './contexts/ConversationsContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Conversation } from './routes/Conversation';
import { Login } from './routes/Login';
import { LoginCallback } from './routes/LoginCallback';
import { Logout } from './routes/Logout';
import { Root } from './routes/Root';

/** Layout for all protected, in-shell routes. Mounts ConversationsProvider
 *  and AppShell once; nested route content renders into <Outlet />. */
function ProtectedAppLayout() {
  return (
    <ProtectedRoute>
      <ConversationsProvider>
        <AppShell>
          <Outlet />
        </AppShell>
      </ConversationsProvider>
    </ProtectedRoute>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <LogtoProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/callback" element={<LoginCallback />} />
            <Route path="/logout" element={<Logout />} />
            <Route element={<ProtectedAppLayout />}>
              <Route path="/" element={<Root />} />
              <Route path="/c/:id" element={<Conversation />} />
            </Route>
          </Routes>
        </ThemeProvider>
      </LogtoProvider>
    </BrowserRouter>
  );
}
